import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-responsive mb-16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", { class: "fit" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-blank-alt-light fw-bold" })
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  colspan: "222222",
  class: "empty-state py-8 px-12 text-center"
}
const _hoisted_5 = { class: "h-100 w-100 d-flex flex-column align-items-center justify-content-center text-center" }
const _hoisted_6 = { class: "h5 title text-primary" }
const _hoisted_7 = { class: "fit text-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-view-light fw-bold" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_table_header = _resolveComponent("v-table-header")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_table_body = _resolveComponent("v-table-body")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_the_professional_resources_show_modal = _resolveComponent("the-professional-resources-show-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.status === 'loaded')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_table, { class: "table-bordered" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_table_header, null, {
                default: _withCtx(() => [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Fecha')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Nombre')), 1),
                    _hoisted_2
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_table_body, null, {
                default: _withCtx(() => [
                  (!_ctx.media.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                        _createElementVNode("td", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('No hay documentos de esta categoría')), 1)
                          ])
                        ])
                      ]))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.media, (file) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: file.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(file.createdAt), 1),
                          _createElementVNode("td", null, _toDisplayString(file.name), 1),
                          _createElementVNode("td", _hoisted_7, [
                            _createVNode(_component_v_button, {
                              variant: "icon",
                              class: "p-0 m-auto",
                              onClick: ($event: any) => {_ctx.currentMedia = file; _ctx.modalToShow = 'the-professional-resources-show-modal'}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_8
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]))
                      }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock(_component_v_loader, { key: 1 })),
    (_ctx.modalToShow === 'the-professional-resources-show-modal')
      ? (_openBlock(), _createBlock(_component_the_professional_resources_show_modal, {
          key: 2,
          media: _ctx.currentMedia,
          onRefreshMedia: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('refresh-media'))),
          onClosed: _cache[1] || (_cache[1] = ($event: any) => {_ctx.modalToShow = null; _ctx.currentMedia = null})
        }, null, 8, ["media"]))
      : _createCommentVNode("", true)
  ], 64))
}